export default __webpack_public_path__ + "static/media/pneumonia.2b9d6583.jpeg";